module.exports = __webpack_public_path__ + "static/beneficio-1-5e81792365ef1f51b862f02716ad1704.png";